module.exports = __webpack_public_path__ + "static/decimal-inputmode-3242a0167821e01b8011e98fcf19e585.png";